(function() {
  document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', async function(e) {
      const btnCustomPayment = e.target.closest('#custom-payment');
      if (btnCustomPayment) { doPaymentTransfer(btnCustomPayment); return; }

      const btnPaymentUSD = e.target.closest('#checkout-usd');
      if (btnPaymentUSD) { doPaymentUSD(btnPaymentUSD); return; }
    });

    async function doPaymentTransfer(btn) {  // ✅ async
      btn.disabled = true;
      btn.textContent = 'Procesando...';
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'transfer-payment': 'true' } })
        });
        window.location.href = '/checkout';
      } catch(e) {
        console.error(e);
        alert('Error de conexión. Intentá de nuevo.');
      } finally {
        btn.disabled = false;
        btn.textContent = 'Transferencia 15% OFF';
      }
    }

    async function doPaymentUSD(btn) {  // ✅ async
      btn.disabled = true;
      btn.textContent = 'Procesando...';

      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { 'transfer-payment': '' } })
        });
        const cartResp = await fetch('/cart.js');
        const cart = await cartResp.json();
        await fetch('https://api.usabaires.com/v1/shopify/exchange-usd-ar', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: cart.items.map(item => ({
              variant_id: item.variant_id,
              product_id: item.product_id,
              quantity: item.quantity,
              is_usd: window.cartItemsUSD?.[item.variant_id] > 0
            }))
          })
        });
        window.location.href = '/checkout';
      } catch(e) {
        console.error(e);
        alert('Error de conexión. Intentá de nuevo.');
      } finally {
        btn.disabled = false;
        btn.textContent = 'Pagar';
      }
    }
  });
})();